import { COLOR_DARK_BLUE } from '@this-core/basic-styles/colors-const';
import styles from './btn-style.module.scss';


const SimpleBigBtn = ({title, width, backgroundColor = COLOR_DARK_BLUE, onClickHandler, isDisable}) => {

  const buttonWidth = {
    width: `${width}px`,
    background: backgroundColor,
  };

  return (
    <button className={`${styles.simpleBigBtn}`} style={buttonWidth} onClick={onClickHandler} disabled={isDisable}>
      <span className='fs-18-24 fw-600 white'>{title}</span>
    </button>
  );
};

export default SimpleBigBtn;